<div class="container">
  <mat-card>
    <div fxLayout="row" fxLayout.lt-md="column">
      <div fxFlex="50%" *ngIf="canViewRoles()">
        <mat-nav-list>
          <mat-list-item [routerLink]="['roles-and-permissions']">
            <mat-icon matListIcon>
              <fa-icon icon="key" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine>{{ "SYSTEM.MANAGE_ROLES_PERMISSIONS" | translate }}</h4>
            <p matLine>
              {{ "SYSTEM.MANAGE_ROLES_PERMISSIONS_DESCRIPTION" | translate }}
            </p>
          </mat-list-item>
        </mat-nav-list>
      </div>

      <div fxFlex="50%" *ngIf="canViewAudit()">
        <mat-nav-list>
          <mat-list-item [routerLink]="['audit-trails']">
            <mat-icon matListIcon>
              <fa-icon icon="money-check" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine>{{ "SYSTEM.AUDIT_TRAILS" | translate }}</h4>
            <p matLine>{{ "SYSTEM.AUDIT_TRAILS_DESCRIPTION" | translate }}</p>
          </mat-list-item>
        </mat-nav-list>
      </div>
    </div>
  </mat-card>
</div>
